import type { TFunction } from "i18next";
import type { AccessList } from "../../../api/access/accessModel";
import type { MenuItem, MenuSection } from "../../../ui/overlays/MenuButton";
import { orderChange } from "../changes/accessChanges";
import type { AccessChanges } from "../changes/useAccessChanges";
import type { GroupNamer } from "../model/groupNames";
import { moveAbove, moveTargets } from "../model/groupOrder";

/**
 * A group's menu, the same on its row in the list and on its own screen: "Move above" each
 * group it may go above (PV3-3), then what else the viewer may do with it, such as renaming or
 * removing it. Only what the viewer may do shows; nothing shows no menu.
 */
export function groupMenuSections(t: TFunction, list: AccessList, groupId: string, namer: GroupNamer, changes: AccessChanges, more: readonly MenuItem[]): readonly MenuSection[] {
  const sections: readonly MenuSection[] = [
    {
      id: "move",
      heading: t("access.moveAbove"),
      items: moveTargets(list.groups, groupId).map((target) => ({
        id: target.groupId,
        label: namer.name(target.groupId),
        action: { kind: "select", onSelect: () => { moveGroup(t, list, namer, changes, groupId, target.groupId); } },
      })),
    },
    { id: "more", items: more },
  ];
  return sections.filter((section) => section.items.length > 0);
}

/** Puts a group directly above another, by a drag or from its menu, if that is a move the viewer may make. */
export function moveGroup(t: TFunction, list: AccessList, namer: GroupNamer, changes: AccessChanges, movingId: string, targetId: string): void {
  const order = moveAbove(list.groups, movingId, targetId);
  if (order === null) return;
  changes.run(orderChange(t, list.projectId, { groupId: movingId, name: namer.name(movingId) }, list.groups.map((group) => group.groupId), order, list.revision));
}
